import Vue from 'vue'
import {Sketch, Photoshop} from 'vue-color'

Vue.component('ChromePicker', Sketch)
Vue.component('PhotoshopPicker', Photoshop)
